import type { DeepPartial } from '@luna/utils-ts';

import type { StandingOrders } from './StandingOrders';

export const HR: DeepPartial<StandingOrders> = {
    handleLocalErrors: {
        enabled: true,
    },
};
